// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__32SZt","sideDrawer":"Navbar_sideDrawer__1igsK"};